<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="'Cambio de Presupuesto'">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <!-- {{ formulario.value | json }} -->
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input (keydown.Tab)="getVendedorOrigen()" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Código Vendedor Origen'" [label]="' Código Vendedor Origen*'" [id]="'vendedorOrigen'"
          formControlName="vendedorOrigen" [control]="formulario.get('vendedorOrigen')"
          (change)="onChangeVendedorOrigen($event);" (keyup)="onChangeVendedorOrigen($event);"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Nombre Vendedor Origen'" [label]="'Nombre Vendedor Origen*'" [id]="'nombreVendedorOrigen'"
          formControlName="nombreVendedorOrigen" [control]="formulario.get('nombreVendedorOrigen')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input (keydown.Tab)="getVendedorDestino()" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Código Vendedor Destino'" [label]="'Código Vendedor Destino*'"
          [id]="'vendedorDestino'" formControlName="vendedorDestino" [control]="formulario.get('vendedorDestino')"
          (change)="onChangeVendedorDestino($event);" (keyup)="onChangeVendedorDestino($event);">
        </app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Nombre Vendedor Destino'" [label]="'Nombre Vendedor Destino*'" [id]="'nombreVendedorDestino'"
          formControlName="nombreVendedorDestino" [control]="formulario.get('nombreVendedorDestino')"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-2">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbAnios"
          formControlName="anio" [control]="formulario.get('anio')" [label]="'Año*'" [id]="'anio'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-2">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbMeses"
          formControlName="mesInicio" [control]="formulario.get('mesInicio')" [label]="'Mes Inicio*'"
          [id]="'mesInicio'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-2">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbMeses"
          formControlName="mesFinal" [control]="formulario.get('mesFinal')" [label]="'Mes Final*'" [id]="'mesFinal'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="">&nbsp;</label>
        <button [disabled]="formulario.invalid" class="btn btn-success btn-block" (click)="getChangePresupuestoVenta()">
          <i class="fa fa-search"></i>
          Buscar</button>
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="">&nbsp;</label>
        <button [disabled]="this.rowData.length === 0" class="btn btn-primary btn-block" (click)="guardar()">
          <i class="fa fa-save"></i>
          Cambiar Presupuesto</button>
      </div>
    </div>
  </div>
  <hr>
  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Indicadores.
    </div>
    <ag-grid-angular [floatingFilter]="true" *ngIf="!listaVacia" #agGrid class=" {{modulo.agGrid.class}}"
      #agGridConsulta [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
      [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
      [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
      [paginationPageSize]="modulo.agGrid.paginacion">
    </ag-grid-angular>
  </div>

</ng-template>